import { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestPreviewsQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { invalidateBondRequestIfClosed, redirectToIssuedBond } from "../utils";

export const useAcceptBondRequestTerms = (
	accountId: SuretyAccountId,
	bondRequestId: SuretyQuoteId,
) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["acceptBondRequestTerms", bondRequestId],
		mutationFn: async () => {
			await patch(
				`/v2/surety/accounts/${accountId}/quotes/${bondRequestId}/accept`,
				undefined,
				"none",
			);
		},
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(bondRequestId) });
			void queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
		},
		onSettled: invalidateBondRequestIfClosed(queryClient, bondRequestId),
	});

	return {
		acceptBondRequestTerms: mutation.mutate,
		acceptBondRequestTermsIsLoading: mutation.isPending,
	};
};
